export const Status_Online = `<svg title="Status_Online" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <circle cx="12" cy="12" r="4" fill="currentcolor"/>
</svg>`;